<template>
  <vContainer>
    <iframe
      :src="survey"
      width="100%"
      height="800"
      style="border:1px solid black;"
    ></iframe>
  </vContainer>
</template>

<script>
export default {
  data() {
    return {
      survey: "https://surveyjs.io/published?id=",
      enableRenewal: true,
      surveyid: this.$route.params.id,
    };
  },
  created() {
    this.survey += this.surveyid;
  },
  methods: {},
  computed: {},
};
</script>

<style lang="scss" scoped></style>
